import { Firm } from '@/types';

export const isCurrentFirmHarvestEnabled = (
  firms: Firm[],
  currentFirmPid?: string,
): boolean => {
  if (!currentFirmPid) {
    return false;
  }

  return firms.find((f) => f.pid === currentFirmPid)?.isHarvestEnabled ?? false;
};
